<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs8 class="pb-2">
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <div v-if="loading" class="px-3 mt-2 py-2">
                        <v-progress-linear
                            :indeterminate="true"
                            color="success"
                        ></v-progress-linear>
                    </div>
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="charge && charge.id"
                            >
                                <!-- <div
                                    class="headline pt-2 mt-1 font-weight-bold mb-0 ml-0"
                                >
                                    {{ charge.merchantName }}
                                </div>

                                <v-divider></v-divider> -->
                                <div class="ml-0 mt-4 pt-1">
                                    <div class="">
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Date:
                                            </div>
                                            <div>
                                                {{
                                                    charge.transactionDate
                                                        | date
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Merchant Name:
                                            </div>
                                            <div>
                                                {{ charge.merchantName }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Amount:
                                            </div>
                                            <div>
                                                {{ charge.originalGrossAmount }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Card Number:
                                            </div>
                                            <div>
                                                {{ charge.cardNumber }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                First Name:
                                            </div>
                                            <div>
                                                {{ charge.firstName }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Last Name:
                                            </div>
                                            <div>
                                                {{ charge.lastName }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-0 pl-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                User:
                                            </div>
                                            <div>
                                                {{ charge.username }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-3">
                                            <div
                                                v-if="!editingDescrption"
                                                class="font-weight-medium"
                                                style="padding-top: 9px !important;"
                                            >
                                                Charge Descrption:
                                            </div>
                                            <div
                                                v-if="
                                                    charge.userDescription &&
                                                        !editingDescrption
                                                "
                                                class="ml-2"
                                                style="padding-top: 9px !important;"
                                            >
                                                {{ charge.userDescription }}
                                            </div>
                                            <v-btn
                                                v-if="!editingDescrption"
                                                @click="editDescrption()"
                                                flat
                                                icon
                                                class="my-0 py-0"
                                                color="success"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-layout>
                                        <div v-if="editingDescrption">
                                            <v-textarea
                                                class="width-300 ml-1 pl-0 mb-2"
                                                rows="3"
                                                outline
                                                hide-details
                                                v-model="charge.userDescription"
                                                label="Charge Descrption"
                                            ></v-textarea>
                                            <v-card-actions
                                                class="width-300 pr-3"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    small
                                                    dark
                                                    color="default"
                                                    @click="
                                                        rollbackDescrption()
                                                    "
                                                    >Cancel</v-btn
                                                >
                                                <v-btn
                                                    small
                                                    color="success"
                                                    @click="saveDescrption()"
                                                    >Save</v-btn
                                                >
                                            </v-card-actions>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>
                </v-card>
            </v-flex>
            <v-flex xs4>
                <v-card
                    class="pa-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <div v-if="loading" class="">
                        <v-progress-linear
                            :indeterminate="true"
                            color="success"
                        ></v-progress-linear>
                    </div>
                    <div v-if="charge">
                        <v-layout
                            row
                            class="mb-1 pl-3"
                            v-bind:class="{
                                'pt-1': !charge.attachments.length,
                            }"
                        >
                            <div
                                class="subheading font-weight-light mt-2 pt-2 mb-1"
                            >
                                {{ getAttachmentText() }}
                            </div>
                            <v-btn
                                small
                                class="ml-2"
                                color="success"
                                @click="openUploadAttachmentDialog"
                                >Upload</v-btn
                            >
                        </v-layout>

                        <div v-for="attachment in charge.attachments">
                            <v-btn
                                class="mt-2 ml-1 px-3"
                                @click="downloadAttachment(attachment)"
                                style="text-transform: unset;"
                            >
                                <v-icon color="blue" left dark>mdi-file</v-icon>
                                {{ attachment.fileName }}
                                <v-icon right>mdi-download</v-icon>

                                <v-icon
                                    right
                                    class="ml-3"
                                    @click.stop="
                                        openDeleteAttachment(attachment)
                                    "
                                    >mdi-close</v-icon
                                >
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="uploadAttachmentDialog" persistent max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pb-2 pl-0 pt-0"
                    >Upload Attachment</v-card-title
                >
                <v-btn
                    small
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickFile()"
                    >Upload</v-btn
                >
                <div class="dropArea" ref="dropArea" v-if="!files.length">
                    Drag and drop a file here
                </div>
                <div v-if="files.length" class="mt-0">
                    {{ files[0].name }}
                </div>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    @change="onFilePicked($event, false)"
                />

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadAttachmentDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFile()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteAttachmentDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Attachment</v-card-title
                >

                <div class="font-weight-medium">
                    This will delete the Attachment:
                    {{ attachmentToDelete.fileName }}
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteAttachmentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteAttachment()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import {
    groupBy,
    formatPhoneNumber,
    truncate,
    pluralize,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        charge: null,
        processing: false,
        loading: true,
        editingDescrption: false,

        uploading: false,
        processing: false,
        files: [],

        uploadAttachmentDialog: false,

        uploadUrl: "",

        attachmentToDelete: {},
        deleteAttachmentDialog: false,

        regID: "",

        pagination: {
            totalCount: 0,
            rowsPerPage: 5,
            page: 1,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    computed: {},
    async created() {
        await this.load();

        const dropArea = this.$refs.dropArea;

        ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            dropArea.addEventListener(eventName, this.preventDefaults, false);
        });

        ["dragenter", "dragover"].forEach((eventName) => {
            dropArea.addEventListener(eventName, this.highlight, false);
        });

        ["dragleave", "drop"].forEach((eventName) => {
            dropArea.addEventListener(eventName, this.unhighlight, false);
        });

        ["click"].forEach((eventName) => {
            dropArea.addEventListener(eventName, this.pickFile, false);
        });

        dropArea.addEventListener("drop", this.handleDrop, false);
    },
    methods: {
        async load() {
            await this.loadCharge();
        },
        async loadCharge() {
            const response = await this.$http.get(
                `api/creditCardCharges/getbyID?id=` + this.$route.params.id,
            );

            this.charge = response.charge;
            this.charge.attachments = response.attachments;
            this.loading = false;
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        getAttachmentText() {
            return (
                this.charge.attachments.length +
                " " +
                pluralize("Attachment", this.charge.attachments.length)
            );
        },
        downloadAttachment(attachment) {
            window.open(attachment.url);
        },
        openDeleteAttachment(attachment) {
            this.attachmentToDelete = attachment;
            this.deleteAttachmentDialog = true;
        },
        async deleteAttachment() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/creditCardCharges/deleteAttachment?id=" +
                        this.attachmentToDelete.id,
                );

                this.processing = false;
                this.deleteAttachmentDialog = false;
                this.load();

                this.$notify({
                    group: "notification",
                    text: "Attachment Deleted",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        truncateText(attachment) {
            return truncate(attachment.fileName, 50);
        },
        editDescrption() {
            this.charge.originalUserDescription = this.charge.userDescription;
            this.editingDescrption = true;
        },
        rollbackDescrption() {
            this.charge.userDescription = this.charge.originalUserDescription;
            this.editingDescrption = false;
        },
        async saveDescrption() {
            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(this.charge));

                data.updatedBy = this.$store.state.authentication.user;

                await this.$http.post("api/creditCardCharges/save", data);

                this.processing = false;
                this.editingDescrption = false;
                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
        openUploadAttachmentDialog() {
            this.uploadAttachmentDialog = true;
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        highlight(e) {
            e.target.classList.add("highlight");
        },
        unhighlight(e, dropArea) {
            e.target.classList.remove("highlight");
        },
        handleDrop(e) {
            const files = e.dataTransfer.files;

            if (!files) return;

            this.files = files;
        },
        pickFile(isNew = false) {
            this.$refs.files.click();
        },
        async onFilePicked(e, isNew = false) {
            this.uploading = true;

            const files = e.target.files;
            this.files = files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminportal/uploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.uploadUrl = response.url;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        closeUploadAttachmentDialog() {
            this.uploadAttachmentDialog = false;
            this.$refs.files.value = null;
            this.files = [];
            this.uploadUrl = "";
        },
        async saveFile() {
            try {
                this.processing = true;

                await this.$http.post("api/creditCardCharges/saveAttachment", {
                    chargeID: this.charge.id,
                    url: this.uploadUrl,
                    fileName: this.files[0].name,
                    uploadedBy: this.$store.state.authentication.user,
                });

                this.processing = false;
                this.closeUploadAttachmentDialog();
                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.spacail-needs-link {
    color: rgb(76, 175, 80);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.tip-grid.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
}
.tip-grid .v-card__text {
    padding-top: 4px !important;
}
.tip-grid .flex {
    padding: 0px !important;
    padding-top: 24px !important;
}
.tip-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
.dropArea {
    border: 2px dashed #ccc;
    width: 100%;
    height: 150px;
    text-align: center;
    padding: 20px;
    cursor: pointer;
}
.highlight {
    border-color: #fc0;
}
</style>
